import AnnuncioGestisci from "./AnnuncioGestisci";

export default AnnuncioGestisci;
